import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import {
  GRAPH_API_SCOPES,
  GRAPH_API_URI,
  HTTP_RETRY_AMOUNT,
  HTTP_TIMEOUT,
  INTEGRATION_WEBHOOK_URL,
  ON_PREM_CLIENT_ID,
} from './injection-token';
import { TimeoutRetryInterceptor } from './interceptor/retry-timeout.interceptor';
import {
  AbEntryService,
  AppointmentService,
  EmailBuilderService,
  EmailService,
  EmailSignatureAiService,
  FrenchMessageService,
  IdentityService,
  InitializationService,
  LeadService,
  NavigationService,
  OnboardingService,
  OutlookMsalService,
  OutlookSessionService,
  PageTitleService,
  PreferencesService,
  TeamMemberService,
  TokenMonitorService,
  TrackerService,
  VerticalService,
} from './services';
import { OutlookService } from './services/outlook/outlook.service';
import {
  CalendarStore,
  ComposeStore,
  EntryStore,
  OnboardingStore,
  OutlookStore,
} from './state';
import { DATABASE_VERTICAL } from '@maximizer/outlook/shared/domain';

export interface OutlookSharedDataAccessConfig {
  integrationWebhookUrl: string;
  graphApiScopes: string[];
  graphApiUri: string;
  onPremClientId: string;
  httpTimeout: number;
  httpRetryAmount: number;
}

export function provideOutlookSharedDataAccess(
  config: OutlookSharedDataAccessConfig,
): EnvironmentProviders {
  return makeEnvironmentProviders([
    AbEntryService,
    AppointmentService,
    CalendarStore,
    ComposeStore,
    EmailBuilderService,
    EmailService,
    EmailSignatureAiService,
    FrenchMessageService,
    IdentityService,
    LeadService,
    NavigationService,
    OnboardingService,
    OnboardingStore,
    OutlookSessionService,
    OutlookService,
    OutlookStore,
    OutlookMsalService,
    PageTitleService,
    PreferencesService,
    TeamMemberService,
    TokenMonitorService,
    TrackerService,
    VerticalService,
    InitializationService,
    EntryStore,
    {
      provide: INTEGRATION_WEBHOOK_URL,
      useValue: config.integrationWebhookUrl,
    },
    { provide: GRAPH_API_SCOPES, useValue: config.graphApiScopes },
    { provide: GRAPH_API_URI, useValue: config.graphApiUri },
    { provide: ON_PREM_CLIENT_ID, useValue: config.onPremClientId },
    { provide: HTTP_TIMEOUT, useValue: config.httpTimeout },
    { provide: HTTP_RETRY_AMOUNT, useValue: config.httpRetryAmount },
    {
      provide: DATABASE_VERTICAL,
      useFactory: (store: OutlookStore) => store.vertical,
      deps: [OutlookStore],
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TimeoutRetryInterceptor,
      multi: true,
    },
  ]);
}
